import styled from 'styled-components';
import { Datepicker } from '@zillow/zrs-rentals';

export const StyledDatepicker = styled(Datepicker)`
    div:nth-child(2){
        z-index: 1 !important;
    }
`;
